import React from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Table from "./CompletedTable";
import MultiOrgDropDown from "./MultiOrg";
import WorkflowHistoryPanel from "./WorkflowHistoryPanel";
import { LoadingSkeletonGroupWise, LoadingSkeletonTableWise } from "../components/LoadingSkeleton";
import { useSelector } from "react-redux";
import { selectEmail } from "../reducer/authSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  btnPadding: {
    marginRight: "8px",
    marginBottom: "8px",
    fontSize: "0.8rem",
    fontWeight: 500,
    minHeight: "36px",
    borderRadius: "8px",
    textTransform: "none",
    padding: "6px 16px",
    transition: "all 0.2s ease",
    '&:hover': {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(111, 41, 129, 0.2)",
    },
    '@media (max-width: 600px)': {
      fontSize: "0.75rem",
      minHeight: "32px",
      padding: "5px 12px",
      marginRight: "6px",
      marginBottom: "6px",
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    '@media (max-width: 600px)': {
      minHeight: '120px',
    },
  },
  content: {
    flexGrow: 80,
    padding: theme.spacing(3),
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '0',
    marginBottom: '16px',
    '@media (max-width: 600px)': {
      gap: '0',
      marginBottom: '12px',
    },
  },
  reportLink: {
    color: "#31AE14",
    cursor: "pointer",
    fontWeight: "bold",
    '@media (max-width: 600px)': {
      fontSize: '14px',
    },
  },
}));

export default function FullWidthGrid(props) {
  const classes = useStyles();
  const email = useSelector(selectEmail);
  const {
    loading,
     _setLoading,
     _dispatch,
    handleDownlaodReport,
    process,
    buttonArray,
     _started,
     _pending,
    buttonName,
    setButtonClicked,
    typeButton,
    setSelectedType,
    selectTypeButton,
    handleHome,
    handleIconCLick,
    menuTitle,
    setMenuTitle,
    selectedTab,
    setSelectedTab,
    searchRecord,
    setManualGenerate,
    manualGenerate,
    setCompleted,
  } = props;
  const [tableData, setTabledata] = React.useState({});

  const [groupIdData, setGroupIddata] = React.useState();
  const [reportAllowed, setReportAllowed] = React.useState(false);

  const handleGroupClick = (item) => {
    setButtonClicked(item);
    setReportAllowed(buttonArray[selectTypeButton][item].report);
    setGroupIddata(buttonArray[selectTypeButton][item].groupId);
    if (buttonArray[selectTypeButton] !== undefined) {
      setTabledata(buttonArray[selectTypeButton][item]);
    }
  };

  React.useEffect(() => {
    let isMounted = true;

    // Compute the correct key based on typeButton
    let computedType = '';
    if (searchRecord !== true) {
      if (typeButton === "FeedbackCompleted") {
        if (isMounted) setMenuTitle(["Feedback", "FeedbackCompleted", "FeedbackExpired"]);
        computedType = "FEEDBACK_COMPLETED";
      } else if (typeButton === "SurveyCompleted") {
        if (isMounted) setMenuTitle(["Survey", "SurveyCompleted", "SurveyExpired"]);
        computedType = "SURVEY_COMPLETED";
      } else if (typeButton === "WorkFlowCompleted") {
        if (isMounted) setMenuTitle(["WorkFlow", "WorkFlowCompleted", "WorkFlowExpired"]);
        computedType = "WORKFLOW_COMPLETED";
      } else {
        if (isMounted) setMenuTitle(["Tests", "Completed", "Expired"]);
        computedType = "COMPLETED";
      }
      if (isMounted) setSelectedType(computedType);
    } else {
      computedType = selectTypeButton;
    }

    // Use computedType directly instead of selectTypeButton to avoid stale state
    if (buttonArray[computedType] !== undefined && buttonArray[computedType][Object.keys(buttonArray[computedType])[0]] !== undefined) {
      if (isMounted) {
        setButtonClicked(Object.keys(buttonArray[computedType])[0]);
        setTabledata(buttonArray[computedType][Object.keys(buttonArray[computedType])[0]]);
        setReportAllowed(buttonArray[computedType][Object.keys(buttonArray[computedType])[0]].report);
        setGroupIddata(buttonArray[computedType][Object.keys(buttonArray[computedType])[0]].groupId);
      }
    } else {
      if (isMounted) setTabledata({});
    }

    return () => {
      isMounted = false;
    };
    // Need to check else condition.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonArray, typeButton]);

  return (
    <main className={searchRecord !== true ? classes.content : `${classes.content} searchrecord-main`}>
      {searchRecord !== true ? (
        <>
          <div className={classes.toolbar} />
          <b>Login ID:</b> {email}
          <br></br>
          <br></br>
          <div className="row">
            <MultiOrgDropDown
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              handleIconCLick={handleIconCLick}
              handleHome={handleHome}
              typeButton={typeButton}
              menuTitle={menuTitle}
            />
          </div>
          <br></br>
        </>
      ) : (
        ""
      )}
      {/* <Grid container spacing={3}> */}
      {typeButton === "WorkFlowCompleted" && (
        <Grid item xs={12} style={{ marginTop: 8 }}>
          <WorkflowHistoryPanel />
        </Grid>
      )}

      {typeButton !== "WorkFlowCompleted" && (loading ? (
        <LoadingSkeletonGroupWise />
      ) : (
        <Grid style={{ paddingBottom: "0px" }} item xs={12}>
          <div className={classes.buttonContainer}>
            {buttonArray[selectTypeButton] !== undefined ? (
              // eslint-disable-next-line array-callback-return
              Object.keys(buttonArray[selectTypeButton]).map((item, index) => {
                if (item !== "tableHeaders") {
                  return (
                    <Button
                      key={`completed${index}`}
                      className={classes.btnPadding}
                      variant="outlined"
                      color={buttonName === item ? "primary" : "default"}
                      style={{background: (buttonName === item) ? 'rgba(111, 41, 129, 0.13)' : ''}}
                      onClick={() => handleGroupClick(item)}
                    >
                      {item}
                    </Button>
                  );
                }
              })
            ) : (
              <></>
            )}
          </div>
        </Grid>
      ))}

      {typeButton !== "WorkFlowCompleted" && (
        <Grid item xs={12}>
          {loading ? (
            <LoadingSkeletonTableWise />
          ) : (
            <Table
              setCompleted={setCompleted}
              setManualGenerate={setManualGenerate}
              manualGenerate={manualGenerate}
              tableData={tableData}
              typeButton={typeButton}
              buttonName={buttonName}
              searchRecord={searchRecord}
            />
          )}
        {/* {tableHeader !== '' ?
            <Table tableData={tableData} tableheader={tableHeader} status='000' />
            :
            <></>
            } */}
      </Grid>
      )}
      {/* Not Started grid removed */}
      {searchRecord !== true && reportAllowed ? (
        process ? (
          /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
          <a
            href="#"
            style={{
              color: "#ffffff",
              backgroundColor: "#6f2981",
              cursor: "pointer",
              fontWeight: "600",
              padding: "10px 20px",
              borderRadius: "8px",
              textDecoration: "none",
              display: "inline-block",
              marginTop: "16px",
              fontSize: "14px",
              boxShadow: "0 2px 8px rgba(111, 41, 129, 0.3)",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#5a2069";
              e.target.style.boxShadow = "0 4px 12px rgba(111, 41, 129, 0.4)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#6f2981";
              e.target.style.boxShadow = "0 2px 8px rgba(111, 41, 129, 0.3)";
            }}
            onClick={(_e) => handleDownlaodReport({ groupId: groupIdData })}
          >
            Click here to download the Report
          </a>
        ) : (
          <span style={{ color: "#6f2981", fontWeight: "500", marginTop: "16px", display: "inline-block" }}>
            Please wait, Your request is being processed...
          </span>
        )
      ) : (
        ""
      )}
    </main>
  );
}
